import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'cfb-errormessage',
  templateUrl: './errormessage.component.html',
  styleUrls: ['./errormessage.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  @Input()  msg:string;
  @Input()  isShow:boolean;
  constructor() { }

  ngOnInit() {}

}
